import { CommunityPageComponent } from './pages/community-page/community-page.component';
import { CongratulationsPageComponent } from './pages/congratulations-page/congratulations-page.component';
import { DashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { FormPageComponent } from './pages/form-page/form-page.component';
import { FormTypePageComponent } from './pages/form-type-page/form-type-page.component';
import { MigCommunitiesGuard } from './guards/mig-communities.guard';
import { MigCorporationGuard } from './guards/mig-corporation.guard';
import { MigFormComponent } from './mig-form.component';
import { MigFormGuard } from './guards/mig-form.guard';
import { MigResidentGuard } from './guards/mig-resident.guard';
import { NgModule } from '@angular/core';
import { ResidentPageComponent } from './pages/resident-page/resident-page.component';
import { RouterModule } from '@angular/router';
import { RouterPageComponent } from './pages/router-page/router-page.component';
import { Routes } from '@angular/router';
import { WizardPageComponent } from './pages/wizard-page/wizard-page.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: MigFormComponent,
      },
      {
        path: ':corporation',
        canActivate: [MigCorporationGuard],
        component: RouterPageComponent,
        children: [
          {
            path: '',
            component: DashboardPageComponent,
          },
          {
            path: 'wizard',
            component: WizardPageComponent,
            children: [
              {
                path: '',
                redirectTo: 'community',
                pathMatch: 'full',
              },
              {
                path: 'community',
                component: CommunityPageComponent,
                canActivate: [MigCommunitiesGuard],
              },
              {
                path: 'resident',
                children: [
                  {
                    path: '',
                    component: ResidentPageComponent,
                  },
                  {
                    path: ':resident',
                    canActivate: [MigResidentGuard],

                    children: [
                      {
                        path: '',
                        component: FormTypePageComponent,
                      },
                      {
                        path: ':caretype',
                        component: FormPageComponent,
                        canActivate: [MigFormGuard],
                      },
                    ],
                  },
                ],
              },
            ],
          },

          {
            path: 'congratulations',
            children: [
              {
                path: ':resident',
                canActivate: [MigResidentGuard],
                component: CongratulationsPageComponent,
              },
            ],
          },
        ],
      },
      {
        path: '**',
        component: ErrorPageComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MigFormRoutingModule {}
